import Axios, { REQUEST_METHOD } from "../axios";

/**
 * Fetch the quarterly CFO dashboard data
 */
export async function apiFetchOutStandingRewardPointsBal() {
  return Axios.fetch({
    url: "/users/outstanding-points-bal-liabilities",
    method: REQUEST_METHOD.GET,
  });
}

/**
 * Fetch wages payable: year-to-date and filtered range
 * @param {{ from: string, to: string }} params - ISO date strings
 */
export async function apiFetchWagesPayable({ fromDate, toDate }) {
  return Axios.fetch({
    url: "/cfo/wages-payable",
    method: REQUEST_METHOD.GET,
    params: { fromDate, toDate },
  });
}

/**
 * Fetch Field Leader wages payable totals
 */
export async function apiFetchFieldLeaderWages({ fromDate, toDate }) {
  return Axios.fetch({
    url: "/cfo/field-leader-wages",
    method: REQUEST_METHOD.GET,
    params: { fromDate, toDate },
  });
}

/**
 * Fetch Brand Ambassador wages payable totals
 */
export async function apiFetchAmbassadorWages({ fromDate, toDate }) {
  return Axios.fetch({
    url: "/cfo/ambassador-wages",
    method: REQUEST_METHOD.GET,
    params: { fromDate, toDate },
  });
}

export default {
  apiFetchFieldLeaderWages,
  apiFetchAmbassadorWages,
  apiFetchOutStandingRewardPointsBal,
  apiFetchWagesPayable,
};
